import "./filterFlights.css";
import { useState } from "react";
import AppFindContiner from "../../design/findContiner/AppFindContiner";
import FilterFlightsHead from "./FilterFlightsHead";
import FilterFlightsData from "./FilterFlightsData";
import { fetchPostAufa } from "../../../faetures/fetch";
import Massage from "../../design/Massage";


function FilterFlights({ openNumDocket, dataForSumA }) {
    console.log("FilterFlights", dataForSumA);
    const [deleteMessage, setDeleteMessage] = useState({ open: false, text: '' });

    const [data, setData] = useState({ office: localStorage.getItem('office_number'), project: "", type: "flights", name: "", status: "*" });

    const deleteAufaData = (deleteData) => {
        const dataToDelete = {
            fname: deleteData["firstName"],
            lname: deleteData["lastName"],
            docketNumber: deleteData["docket"],
            price: deleteData["price"],
            approved: deleteData["app"],
            project: data.project,
            type: data.type,
            name: data.name
        }
        console.log("dataToDelete", dataToDelete);

        fetchPostAufa('delete-aufa-data', dataToDelete)
            .then(res => {
                console.log(res);
                if (res.status == 200)
                    setDeleteMessage({ open: true, text: "נמחק בהצלחה" });
                else if (res.status == 0)
                    setDeleteMessage({ open: true, text: "שגיאה במחיקת הזמנה" });
                else if (res.status == 1)
                    setDeleteMessage({ open: true, text: "אין אפשרות למחיקת נסיעות פנים" });
                else if (res.status == 2)
                    setDeleteMessage({ open: true, text: "אין לך הרשאה למחיקת נתונים" });
            }

            )
            .catch(err => setDeleteMessage({ open: true, text: "שגיאה במחיקת הזמנה" })
            )
    }

    return (<>

        {deleteMessage.open && deleteMessage.text && (
            <Massage
                text={deleteMessage.text}
                animation={true}
                setClose={() => {
                    setDeleteMessage({ open: false, text: '' });
                }}
            />
        )}


        <AppFindContiner
            HeadComp={FilterFlightsHead}
            DataComp={FilterFlightsData}
            data={data}
            setData={setData}
            className={"AppFilterFlightsAufa"}
            host={"aufa/filter"}
            propsData={{ openNumDocket: openNumDocket, deleteAufaData: deleteAufaData }}
            propHead={{ dataFromSumA: dataForSumA }}
        />

    </>
    )
}


export default FilterFlights;